export const types = {
  LOGIN_REQUEST: 'LOGIN/LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN/LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN/LOGIN_FAILURE',
  LOGOUT_REQUEST: 'LOGIN/LOGOUT_REQUEST',
  VERIFY_REQUEST: 'LOGIN/VERIFY_REQUEST',
  VERIFY_SUCCESS: 'LOGIN/VERIFY_SUCCESS',
  VERIFY_FAILURE: 'LOGIN/VERIFY_FAILURE',
  STOP_IMPERSONATING_REQUEST: 'LOGIN/STOP_IMPERSONATING',
  REQUEST_RESET_EMAIL_REQUEST: 'LOGIN/REQUEST_RESET_EMAIL_REQUEST',
  REQUEST_RESET_EMAIL_SUCCESS: 'LOGIN/REQUEST_RESET_EMAIL_SUCCESS',
  REQUEST_RESET_EMAIL_FAILURE: 'LOGIN/REQUEST_RESET_EMAIL_FAILURE',
  RESET_PASSWORD_REQUEST: 'LOGIN/RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'LOGIN/RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'LOGIN/RESET_PASSWORD_FAILURE',
};

export const initialState = {
  error: null,
  isLoading: false,
  isUpdating: false,
  twoFactorChallengeToken: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.LOGIN_SUCCESS:
      const { twoFactorChallengeToken } = action;
      return {
        ...state,
        isLoading: false,
        twoFactorChallengeToken: twoFactorChallengeToken || null,
      };
    case types.LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        twoFactorChallengeToken: null,
      };
    case types.VERIFY_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.VERIFY_SUCCESS:
      return { ...state, isLoading: false, twoFactorChallengeToken: null };
    case types.VERIFY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        twoFactorChallengeToken: action.clearToken
          ? null
          : state.twoFactorChallengeToken,
      };
    case types.REQUEST_RESET_EMAIL_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.REQUEST_RESET_EMAIL_SUCCESS:
      return { ...state, isLoading: false };
    case types.REQUEST_RESET_EMAIL_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.RESET_PASSWORD_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.RESET_PASSWORD_SUCCESS:
      return { ...state, isUpdating: false };
    case types.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.error,
        message: action.message,
      };
    default:
      return state;
  }
};

export const actions = {
  login: (email, password) => ({ type: types.LOGIN_REQUEST, email, password }),
  logout: () => ({ type: types.LOGOUT_REQUEST }),
  verify: (challengeToken, twoFactorCode) => ({
    type: types.VERIFY_REQUEST,
    challengeToken,
    twoFactorCode,
  }),
  stopImpersonating: () => ({ type: types.STOP_IMPERSONATING_REQUEST }),
  requestResetEmail: (email) => ({
    type: types.REQUEST_RESET_EMAIL_REQUEST,
    email,
  }),
  resetPassword: (email, password, password_confirmation, token) => ({
    type: types.RESET_PASSWORD_REQUEST,
    email,
    password,
    password_confirmation,
    token,
  }),
};
